import React, { useEffect, useState } from "react";
import { TokensMap } from "../../hooks/useTokenBalances";
import { Menu, Button, Input, VisuallyHidden } from "@chakra-ui/react";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { ChevronDown } from "lucide-react";

interface ITokenSelectInput {
  className?: string;
  label: string;
  name: string;
  tokensMap: TokensMap;
  sync?: (value: string) => void;
  options: Array<Object>; // Could be better
  isDisabled: boolean;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  value: string;
}

const TokenSelectInput: React.FC<ITokenSelectInput> = ({
  className,
  label,
  name,
  tokensMap,
  sync,
  options,
  isDisabled,
  register,
  setValue,
  value,
}: ITokenSelectInput) => {
  const [tokenAddress, setTokenAddress] = React.useState("");
  const handleClick = (selectedValue: string) => {
    setValue(name, selectedValue, { shouldValidate: true }); // Form validation
    setTokenAddress(selectedValue);
  };

  const labelParsed =
    value !== "" && tokensMap[tokenAddress]
      ? `${label} ${tokensMap[tokenAddress]?.balance} ${tokensMap[tokenAddress]?.symbol}`
      : "Please select token";

  const tokenAddressValidator = register(name);

  const [synced, setSynced] = useState("");
  useEffect(() => {
    if (sync && tokenAddress !== synced) {
      setSynced(tokenAddress);
      if (tokenAddress !== "") {
        sync(tokenAddress);
      }
    }
    // eslint-disable-next-line
  }, [tokenAddress]);

  useEffect(() => {
    if (value === "") {
      setSynced("");
      setTokenAddress("");
    }
  }, [value]);

  return (
    <section>
      <Menu.Root>
        <Menu.Trigger asChild>
          <Button width="100%" disabled={isDisabled}>
            {labelParsed} <ChevronDown size={16} />
          </Button>
        </Menu.Trigger>
        <Menu.Positioner>
          <Menu.Content borderRadius="0px" border="1px solid" width="100%">
            {options.map((option: any, key) => {
              // TODO: remove this any
              return (
                <Menu.Item
                  value={option.value}
                  key={key}
                  onClick={handleClick.bind(this, option.value)}
                >
                  {option.label}
                </Menu.Item>
              );
            })}
          </Menu.Content>
        </Menu.Positioner>
      </Menu.Root>
      {/* Hidden text field for form validation: */}
      <VisuallyHidden>
        <Input
          name={name}
          value={tokenAddress}
          onChange={tokenAddressValidator.onChange}
          onBlur={tokenAddressValidator.onBlur}
          ref={tokenAddressValidator.ref}
        />
      </VisuallyHidden>
    </section>
  );
};

export default TokenSelectInput;
